import { render, staticRenderFns } from "./box5.vue?vue&type=template&id=254528d1&scoped=true"
import script from "./box5.vue?vue&type=script&lang=js"
export * from "./box5.vue?vue&type=script&lang=js"
import style0 from "./box5.vue?vue&type=style&index=0&id=254528d1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254528d1",
  null
  
)

export default component.exports